var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ClientTable',{attrs:{"clientList":_vm.clientList,"loadingComplete":_vm.loadingComplete,"error":_vm.error}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }